import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  show: false, // Finder
  snotes: false,
  schrome: false,
  sghostty: false,
  sorbstack: false,
  sspotify: false,
  szed: false,
  binEmptied: false,
};

export const windowSlice = createSlice({
  name: "window",
  initialState,
  reducers: {
    showWindow: (state, action) => {
      state.show = action.payload;
    },
    showNotes: (state, action) => {
      state.snotes = action.payload;
    },
    showChrome: (state, action) => {
      state.schrome = action.payload;
    },
    showGhostty: (state, action) => {
      state.sghostty = action.payload;
    },
    showOrbStack: (state, action) => {
      state.sorbstack = action.payload;
    },
    showSpotify: (state, action) => {
      state.sspotify = action.payload;
    },
    showZed: (state, action) => {
      state.szed = action.payload;
    },
    // Once emptied, the Bin stays empty (the store is kept between visits).
    emptyBin: (state) => {
      state.binEmptied = true;
    },
  },
});

export const { showWindow, showNotes, showChrome, showGhostty, showOrbStack, showSpotify, showZed, emptyBin } =
  windowSlice.actions;

export default windowSlice.reducer;
